// extracted by mini-css-extract-plugin
module.exports = {"main":"star_main__O2s_G","starPath":"star_starPath__tU5Y2","atv":"star_atv__s8k58"};